import React from 'react';
import './App.css';
import Home from './pages/Home';
import References from './pages/References';
import Form from './pages/Form';
import Results from './pages/Results';
import {
  Routes,
  Route,
} from 'react-router-dom';




function App() {
  return (
    <div>
    
          <div className="App ">
        <Routes>
        <Route exact path='/calculadora-de-salarios' element={< Home />}></Route>
        <Route exact path='/calculadora-de-salarios/datos' element={< Form />}></Route>
        <Route exact path='/calculadora-de-salarios/referencias' element={< References />}></Route>
        <Route exact path='/calculadora-de-salarios/resultados' element={< Results />}></Route>
    </Routes>
    </div>
    </div>

    
  );
}

export default App;
